import { useEffect, useMemo, useState } from "react";
import TableService from "../../../services/tableService";
import FilterTable from "../FilterTable";

export function FilterTableWrapper(props) {
    const [selectedRowId, setSelectedRowId] = useState();

    useEffect(() => {
        props.onRowSelect?.(props.data.find((row) => row.id === selectedRowId));
    }, [selectedRowId]);

    const data = useMemo(
        () =>
            TableService.getPreparedDataForCollapsibleTable(
                props.fieldsConfig,
                props.data,
                [],
                [],
                () => {},
            ),
        [props.fieldsConfig, props.data],
    );

    return (
        <FilterTable
            // @ts-ignore
            data={data}
            initialParams={props.initialParams}
            countRecords={props.countRecords || props.data.length}
            selectedItemId={selectedRowId}
            headersConfig={props.fieldsConfig}
            showCleanFilterIcon={props.filtersOpts?.showCleanFilterIcon}
            showContextMenu={false}
            showCounterRecords={false}
            setSelectedRowId={setSelectedRowId}
            selectedRowId={selectedRowId}
            showDetailsIcon={false}
            showCheckbox={false}
            alwaysExpandedFilters={props.filtersOpts?.alwaysExpandedFilters}
            onSearchCb={props.onSearchFiltersChange}
            hideFiltersIconCol={props.filtersOpts?.hideFiltersIconCol}
            style={props.tableStyle}
            withPagination={props.localPagination != null}
            resetPageNumber={props.localPagination?.resetPageNumber}
            page={props.localPagination?.page}
            rowsPerPage={props.localPagination?.pageSize}
            onPageChange={props.localPagination?.handleChangePageWithSearchParams}
            onRowsPerPageChange={props.localPagination?.handleChangePageSizeWithSearchParams}
            sortParams={props.localPagination?.sortParams}
            handleSort={props.localPagination?.handleSort}
            isLoading={props.isLoading}
            disableRowHighlight={props.disableRowHighlight}
        />
    );
}
